export const authorize = '/api/Authorization/authorizeByApplication/';
export const getAllExports = '/api/Exports';
export const previewExport = '/api/Exports/preview';
export const save = '/api/Exports/save';
export const s3Locations = '/api/Destinations/AwsS3Locations';
export const flipActiveExport = (id, isActive) => `/api/Exports/${id}/${isActive}`;
export const deleteExportById = (id) => `/api/Exports/delete/${id}`;
export const getExportById = (id) => `/api/Exports/${id}`;
export const runExportById = (id, affectRunTime) => `/api/Exports/${id}/run/${affectRunTime}`;
export const getColumnsByType = (type) => `/api/Columns/${type}`;